import "@fontsource/schibsted-grotesk/400.css";
import "@fontsource/schibsted-grotesk/500.css";
import "@fontsource/schibsted-grotesk/600.css";
import "@fontsource/schibsted-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "./styles/app.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Bootstrap } from "./app/Bootstrap";
import { isMsalPopup } from "./auth/popup";
import { ThemeProvider } from "./theme/ThemeProvider";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("index.html is missing #root");
}

if (isMsalPopup(window)) {
  // The sign-in popup, back from Microsoft: hand its answer to the app's own
  // window, which closes this one. The app doesn't start here (#252; ADR 0093).
  void import("@azure/msal-browser/redirect-bridge").then(({ broadcastResponseToMainFrame }) =>
    broadcastResponseToMainFrame(),
  );
} else {
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider>
        <Bootstrap />
      </ThemeProvider>
    </StrictMode>,
  );
}
